<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      no-data-text="No invoices."
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>
          <v-btn
            flat
            depressed
            small
            left
            :href="props.item.invoice_path"
            target="_blank"
          >view invoice</v-btn>
        </td>
        <td>{{ props.item.user ? props.item.user.name : 'N/A' }}</td>
        <td>{{ props.item.status ? props.item.status : 'pending' }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>
          <v-tooltip top>
            <v-btn slot="activator" icon class="mx-0" v-if="$can('mark-paid', 'invoices') && props.item.status === 'pending'" @click="markPaid(props.item.id)">
              <v-icon color="teal">done</v-icon>
            </v-btn>
            Mark paid
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <AddCaseInvoiceButton v-on="on" :casesid="casesid"></AddCaseInvoiceButton>
      </template>
      Add Case Invoice
    </v-tooltip>
  </div>
</template>

<script>
  import invoicesAPI from '@/api/invoice'
  import AddCaseInvoiceButton from '@/components/buttons/AddCaseInvoiceButton'
  import { mapGetters } from 'vuex'

  export default {
    components: { AddCaseInvoiceButton },
    data () {
      return {
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Invoice path', value: 'invoice_path' },
          { text: 'Vendor', value: 'vendors_id' },
          { text: 'Status', value: 'status' },
          { text: 'Created Date', value: 'created_at' },
          { text: 'Actions', value: 'actions' }
        ]
      }
    },
    computed: {
      ...mapGetters({
        // caseById: 'getCaseById',
        // getAllCases: 'getAllCases',
        items: 'currentCaseVendorInvoices'
      })
    },
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    methods: {
      markPaid (itemId) {
        invoicesAPI.markPaid(itemId).then(() => {
          this.loadLinkedInvoices()
        }, () => {})
      },
      loadLinkedInvoices () {
        this.$store.dispatch('getCaseInvoices', this.casesid)
      }
    },
    created () {
      this.$bus.$on('invoice:uploaded', () => {
        this.$store.dispatch('getCaseInvoices', this.casesid)
      })
      this.$store.dispatch('getCaseInvoices', this.casesid)
    }
  }
</script>



// WEBPACK FOOTER //
// CaseInvoicesDataTable.vue?6b2ae2d8